const FIELD_NAME_PATTERN = /^status_match_application\[([^\]]+)\]$/

export function statusMatchField(form, name) {
  if (!form) return null
  return form.querySelector(`[name="status_match_application[${name}]"]`)
}

export function collectStatusMatchApplicationFields(form) {
  if (!form) return {}

  const out = {}
  form.querySelectorAll("[name]").forEach((element) => {
    const match = element.name.match(FIELD_NAME_PATTERN)
    if (!match || element.type === "file") return

    const key = match[1]
    if (element.type === "radio") {
      if (element.checked) out[key] = element.value
      return
    }
    if (element.type === "checkbox") {
      if (element.checked) out[key] = element.value
      return
    }
    out[key] = element.value
  })

  return out
}

export function applicantFullNameFromFields(form) {
  const firstName = statusMatchField(form, "first_name")?.value?.trim() || ""
  const lastName = statusMatchField(form, "last_name")?.value?.trim() || ""
  return [firstName, lastName].filter(Boolean).join(" ")
}

export function selectedOptionText(field, selectPrefix = "Select") {
  const text = field?.selectedOptions?.[0]?.text?.trim() || field?.value?.trim() || ""
  if (!text || text.startsWith(selectPrefix)) return ""
  return text
}
